<template>
  <div class="c-header clearfix">
    <div class="header-logo">
      <a href="/">
        <img src="./img/header-logo-white-xd.png">
      </a>
    </div>
    <!-- <div class="credit">
      <a href="javascript:;" @click.prevent="showQrcode">征信查询</a>
      <div class="qrcode-box">
        <i class="close-btn" @click="closeQrcode"></i>
        <div class="qrcode-content">
          <p>风险信用不可小觑</p>
          <p>您有一份征信报告待查看</p>
          <div class="qrcode" id="qrcode" ref="qrcode"></div>
          <div class="foot">扫码即刻查征信</div>
        </div>
      </div>
    </div> -->
    <ul class="nav">
      <li v-for="(item,index) in navList" :key="index">
        <a @click="goUrl(item.url,index)" :class="{ active:index==currentPage}">{{item.name}}</a>
      </li>
    </ul>
  </div>
</template>

<script>
import $ from "jquery";
import QRCode from "qrcodejs2";
export default {
  name: "c-header",
  data() {
    return {
      navList: [
        {
          name: "联系我们",
          url: "/contactUs",
        },
        {
          name: "加入我们",
          url: "/joinUsMain",
        },
        {
          name: "公司公告",
          url: "/announcementList",
        },
        {
          name: "场景服务",
          url: "/sceneService",
        },
        {
          name: "关于八戒小贷",
          url: "/aboutUs",
        },
        {
          name: "首页",
          url: "/index",
        },
      ],
      currentPage: 5,
    };
  },
  mounted() {
    let currentUrl = this.$route.path;
    this.navList.forEach((item, index) => {
      if (item.url === currentUrl) {
        this.currentPage = index;
      }
    });
  },
  methods: {
    goUrl(url, index) {
      this.$router.push(url);
      this.currentPage = index;
    },
    showQrcode() {
      $(".qrcode").html("");
      let qrcode = new QRCode("qrcode", {
        width: 154, // 设置宽度
        height: 154, // 设置高度
        text: "https://m.tianxiaxinyong.cn/cooperation/crp-v2/per-detail.html?channel=K3lRa1Z6WE9aY2Iveng0VHNoN2d3Zz09",
      });
      $(".qrcode-box").slideDown(300, "linear", function () {
        $(".qrcode-content").fadeIn(500);
      });
    },
    closeQrcode() {
      $(".qrcode-box").fadeOut();
      $(".qrcode-content").hide();
    },
  },
};
</script>

<style rel="stylesheet/less" lang="less" scoped>
@import "..\..\global\css\mixin\mixin.less";
.c-header {
  background-color: rgba(48, 47, 46, 0.4);
  font-size: 22px;
  width: 1200px;
  height: 80px;
  line-height: 80px;
  // overflow: hidden;
  position: fixed;
  top: 0;
  left: 50%;
  margin-left: -600px;
  z-index: 999;
  .header-logo {
    float: left;
    width: 105px;
    height: 80px;
    text-align: center;
    position: relative;
    img {
      width: 166px;
      vertical-align: middle;
      // position: relative;
      // bottom: 3px;
    }
  }
  .credit {
    float: right;
    width: 124px;
    height: 80px;
    text-align: center;
    position: relative;
    margin-left: 55px;
    font-size: 16px;
    a {
      position: absolute;
      width: 124px;
      height: 40px;
      line-height: 40px;
      left: 0;
      top: 20px;
      color: #fff;
      background: url("./img/credit.png") no-repeat;
    }
    .qrcode-box {
      display: none;
      position: absolute;
      width: 264px;
      height: 447px;
      top: 60px;
      left: -70px;
      box-sizing: border-box;
      padding: 137px 36px 26px 36px;
      background: url("./img/qrcode-box.png") no-repeat;
      .close-btn {
        position: absolute;
        width: 20px;
        height: 20px;
        top: 145px;
        right: 40px;
        background: url("./img/qrcode-close.png") no-repeat;
        cursor: pointer;
      }
      .qrcode-content {
        width: 160px;
        height: 260px;
        padding: 24px 16px 0px 16px;
        display: none;
        p {
          height: 20px;
          line-height: 20px;
          color: #000000;
          font-size: 12px;
        }
        .qrcode {
          width: 154px;
          height: 154px;
          padding: 4px;
          border: 2px solid #ffc39c;
          margin-top: 5px;
        }
        .foot {
          width: 155px;
          height: 38px;
          margin: 0 auto;
          line-height: 38px;
          text-align: center;
          background: url("./img/qrcode-line.png") no-repeat center;
          color: #000000;
          font-size: 12px;
        }
      }
    }
  }
  .nav {
    li {
      float: right;
      cursor: pointer;
      margin-left: 55px;
      height: 80px;
      a {
        color: #666;
        font-size: 16px;
        padding: 5px 0;
        &:hover {
          color: #ffffff;
          border-bottom: 2px solid #666;
        }
        &.active {
          color: #ffffff;
          border-bottom: 2px solid #666;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// index.vue?5b8ba3e2